export const MainConfig = {
    AppDetails: {
        app_name: "Same Day Logistics",
        app_description: "Same Day Logistics org",
        app_identifier: "com.sameday.logis",
        ios_app_version: "1.7.0",
        android_app_version: 8
    },

    FirebaseConfig: {
        apiKey: "AIzaSyDW0guFtzSHrFTJlNPsWTVpySURiQr5w6o",
        authDomain: "samedaylogistics-org.firebaseapp.com",
        databaseURL: "https://samedaylogistics-org-default-rtdb.firebaseio.com",
        projectId: "samedaylogistics-org",
        storageBucket: "samedaylogistics-org.appspot.com",
        messagingSenderId: "192115484389",
        appId: "1:192115484389:web:e94180029e1bade0a3560c",
        measurementId: "G-W96VYPSQ7R"
 
    },

    Google_Map_API_Key: {
        ios: "AIzaSyCOkxEvZLHerjDg_n93wTrOKA7ryx4VRT8",
        android: "AIzaSyCILSBYv7dDcy1A_Pvrd6beKqaLUUdzkqc",
        web: "AIzaSyDW0guFtzSHrFTJlNPsWTVpySURiQr5w6o",
    },
    Expo: {
        projectId: "351b7dcc-e5f9-4de5-b52c-78fbc204498e"
      }
}